export default __webpack_public_path__ + "static/media/eye.30fd2a7c.svg";